import React,{Component} from "react";
import "./Disclosure.css";

class Disclosure extends Component{
    render(){
        return(
                <>
                <h1
          style={{ textAlign: "center", marginTop: "100px", fontSize: "100px" }}
        >
          Responsible Disclosure Policy
        </h1>
        <p>
        At GIMS, we take the security of our systems seriously, and it is our constant endeavor to make our website a safe place for our customers to browse. However, in the rare case when some security researcher or member of the general public identifies a vulnerability in our systems, and responsibly shares the details of it with us, we appreciate their contribution, work closely with them to address such vulnerabilities with urgency, and if they want, publicly acknowledge their contribution. GIMS reserves all the rights to validate the reports to be valid or not on the basis of impact of vulnerability.

<br/>* To be eligible for recognition, you must
<br/>
<br/>* Be the first person to responsibly disclose the bug.
<br/>
<br/>* Report a bug that could compromise our users' private data, circumvent the system's protections, or enable access to a system within our infrastructure.
<br/>
<br/>* Types of Recognition
<br/>
<br/>* Hall of Fame
<br/>
<br/>* Rules of Engagement
<br/>
<br/>* You give us reasonable time to investigate and mitigate a vulnerability that you report.
<br/>
<br/>* Please refrain from accessing sensitive information (by using a test account and/or system), performing actions that may negatively affect other GIMS users (denial of service), or sending reports from automated tools.
<br/>
<br/>* You do not exploit a security vulnerability that you discover for any reason. (This includes demonstrating additional risk, such as attempted compromise of sensitive company data or probing for additional issues.)
<br/>
<br/>* Violating any laws or breaching any agreements in order to discover vulnerabilities.
<br/>
<br/>* You do not publicly disclose details of a security vulnerability that you've reported without GIMS's permission.
<br/>
<br/>* Programme terms
<br/>
<br/>* We recognise security researchers who help us to keep users safe by reporting vulnerabilities in our services. Recognition for such reports are entirely at GIMS’s discretion, based on risk, impact and other factors. For recognition in GIMS’s Hall of Fame, you first need to meet the following requirements:
<br/>
<br/>* Adhere to our Responsible Disclosure Policy
<br/>
<br/>* Report a security bug: identify a vulnerability in our services or infrastructure which creates a security or privacy risk. (Note that GIMS ultimately determines the risk of an vulnerability, and that many software bugs are not security vulnerabilities.)
<br/>
<br/>* Your report must describe a problem involving one of the products or services listed under "Scope".
<br/>
<br/>* We specifically exclude certain types of potential security vulnerabilities; these are listed under "Exclusions”.
<br/>
<br/>* If you inadvertently cause a privacy violation or disruption (such as accessing account data, service configurations or other confidential information) while investigating an vulnerability, make sure that you disclose this in your report.
<br/>
<br/>* In turn, we will follow these guidelines when evaluating reports under our responsible disclosure programme:
<br/>
<br/>* We investigate and respond to all valid reports. Due to the volume of reports that we receive, however, we prioritise evaluations based on risk and other factors, and it may take some time before you receive a reply.
<br/>
<br/>* We determine recognition in hall of fame based on a variety of factors, including (but not limited to) impact, ease of exploitation and quality of the report. Note that extremely low-risk vulnerabilities may not qualify for hall of fame at all.
<br/>
<br/>* In the event of duplicate reports, we give recognition to the first person to submit a vulnerability. (GIMS determines duplicates and may not share details on the other reports.)
<br/>
<br/>* Note that your use of GIMS services including for the purposes of this programme, is subject to GIMS’s Terms and Policies. We may retain any communications about security vulnerabilities that you report for as long as we deem necessary for programme purposes, and we may cancel or modify this programme at any time.
<br/>
<br/>* Scope
<br/>
<br/>* Android GIMS
<br/>
<br/>* iOS GIMS
<br/>
<br/>* Android Delivery Partner GIMS
<br/>
<br/>* iOS Business GIMS
<br/>
<br/>* https://GIMSnow.com
<br/>
<br/>* https://GIMS.co.in
<br/>
<br/>* How to Report a Vulnerability?
<br/>
<br/>* If you happen to have identified a vulnerability on any of our web or mobile app properties, we request you to follow the steps outlined below:
<br/>
<br/>* Please submit the vulnerability report form with the necessary details to recreate the vulnerability scenario. This may include screenshots, videos or simple text instructions.
<br/>
<br/>* If possible, share with us your contact details (phone number), so that our security team can reach out to you if further inputs are needed to identify or close the problem.
<br/>
<br/>* If the identified vulnerability can be used to potentially extract information of our customers or systems, or impair our system’s ability to function normally, then please refrain from actually exploiting such a vulnerability. This is absolutely necessary for us to consider your disclosure a responsible one.
<br/>
<br/>* While we appreciate the inputs of Whitehat hackers, we may take legal recourse if the identified vulnerabilities are exploited for unlawful gains or getting access to restricted customer or system information or impairing our systems.
<br/>
<br/>* Report a Vulnerability
<br/>
<br/>* Send an email to security@GIMSnow.com
<br/>
<br/>* Qualifying Vulnerabilities
<br/>
<br/>* Any design or implementation issue that is reproducible and substantially affects the security of GIMS users is likely to be in scope for the program. Common examples include:
<br/>
<br/>* Injections
<br/>
<br/>* Cross Site Scripting (XSS)
<br/>
<br/>* Cross Site Request Forgery (CSRF)
<br/>
<br/>* Remote Code Execution (RCE)
<br/>
<br/>* Authentication/Authorisation flaws
<br/>
<br/>* Domain take-over vulnerabilities
<br/>
<br/>* Able to take-over other GIMS user accounts (while testing, use your own another test account to validate)
<br/>
<br/>* Any vulnerability that can affect the GIMS Brand, user data and financial transactions
<br/>
<br/>* Exclusions
<br/>
<br/>* The following bugs are unlikely to be eligible:
<br/>
<br/>* Vulnerabilities found through automated testing
<br/>
<br/>* "Scanner output" or scanner-generated reports
<br/>
<br/>* Publicly released CVE’s or 0-days in internet software within 90 days of their disclosure
<br/>
<br/>* "Advisory" or "Informational" reports that do not include any GIMS testing or context
<br/>
<br/>* Vulnerabilities requiring MITM or physical access to the victim’s unlocked device.
<br/>
<br/>* Denial of Service attacks
<br/>
<br/>   ~  SPF and DKIM issues
<br/>    
<br/>   ~  Content injection
<br/>    
<br/>   ~  Hyperlink injection in emails
<br/>    
<br/>   ~  IDN homograph attacks
<br/>    
<br/>   ~  RTL Ambiguity
<br/>
<br/>* Content Spoofing
<br/>
<br/>* Vulnerabilities relating to Password Policy
<br/>
<br/>* Full-Path Disclosure on any property
<br/>
<br/>* Version number information disclosure
<br/>
<br/>* Third-party applications on the GIMS Application directory (identified by the existence of a "Report this app" link on the app's page). Please report vulnerabilities with these services to the creator of that specific application.
<br/>
<br/>* Clickjacking on pre-authenticated pages, or the non-existence of X-Frame-Options, or other non-exploitable clickjacking vulnerabilities
<br/>
<br/>* CSRF-able actions that do not require authentication (or a session) to exploit
<br/>* Reports related to the following security-related headers
<br/>
<br/>   ~ Strict Transport Security (HSTS)
<br/>     
<br/>   ~ XSS mitigation headers (X-Content-Type and X-XSS-Protection)
<br/>     
<br/>   ~ X-Content-Type-Options
<br/>     
<br/>   ~ Content Security Policy (CSP) settings (excluding nosniff in an exploitable scenario)
<br/>
<br/>* Bugs that do not represent any security risk
<br/>
<br/>* Security bugs in third-party applications or services built on the GIMS API - please report them to the third party that built the application or service
<br/>
<br/>* Security bugs in software related to an acquisition for a period of 90 days following any public announcement
<br/>
<br/>* HTTP TRACE or OPTIONS methods enabled
<br/>
<br/>* Non-sensitive (i.e., non-session) cookies missing the Secure or HttpOnly flags
<br/>
<br/>* Tap jacking
<br/>
<br/>* Mobile client issues require a rooted device and/or outdated OS version or SSL pinning issues.
<br/>
<br/>* Subdomain takeovers without supporting evidence
<br/>
<br/>* Missing best practices in SSL/TLS configuration.
<br/>
<br/>* The Vulnerabilities that cannot be used to exploit other users or GIMS *  e.g., self-XSS or having a user paste JavaScript into the browser console
<br/>
<br/>* Open ports without an accompanying proof-of-concept demonstrating vulnerability
<br/>
<br/>* Vulnerabilities in the whitehat report form
<br/>
<br/>* Submitting complaints about services
<br/>
<br/>* Making fraud reports and/or suspicions of fraud reports from false mail or phishing e-mails
<br/>
<br/>* Reporting viruses.
<br/>
<br/>* Submitting complaints or questions about the availability of the website.
<br/>
<br/>* Acknowledgements
<br/>
<br/>* We do not have a bounty/cash reward program for such disclosures, but we express our gratitude for your contribution in different ways. For genuine ethical disclosures, we would be glad to publicly acknowledge your contribution in this section on our website. Of course, this will be done if you want a public acknowledgement.
<br/>
<br/>* Hall Of Fame
<br/>
<br/>* GIMS thanks the following People for finding and responsibly disclosing security vulnerabilities in GIMS owned Apps, products or services. We are grateful for their contribution and efforts towards the security of GIMS.
        </p>
                </>
        );
    }
}
export default Disclosure;